// Author Lin
// Date 2021-09-27 20:32:25

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingMaterialBatchingModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingMaterialBatching(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
